<section class="container">

  <div class="row mt-4">
    <div class="mt-3 mb-3">
      <h1 class="mb-1">{{'interfaces.title' | translate}}</h1>
      <p style="font-family:'MyFont-Light';">{{'headlines.subInterfaces' | translate}}<br/>{{'moreInfosAt' | translate}} <a href="{{link}}" target="_blank" class="text-decoration-none" style="color:var(--warmOrange);">{{'interfaces.openApiDocs' | translate}}</a>
    </p>
  </div>
</div>

<mat-card class="mt-3">
  <mat-tab-group mat-stretch-tabs mat-align-tabs="start">
    <mat-tab label="Interfaces">
      <div class="p-4">
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined me-2">api</mat-icon>
          {{'interfaces.title' | translate}}
        </ng-template>
        <div class="row mt-4">
          <div class="col-12">
            <section class="mt-1 filter-section d-flex flex-row flex-wrap align-items-center">
              <div>
                <button mat-button class="orange-button mb-2" (click)="openDialogNewInterface();" [disabled]="!interfacesUserRights_create">
                  <mat-icon>add_circle</mat-icon>
                  {{'add_new' | translate}}
                </button>
              </div>
              <mat-form-field class="pt-3 m-2 my-0 search">
                <mat-label>{{'search_title' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="{{'search' | translate}}" #input>
                <mat-icon matPrefix>search</mat-icon>
              </mat-form-field>
            </section>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <div class="rounded shadow-sm mb-4" id="table-container">
              <table mat-table [dataSource]="listdata" matSort #interfacesSort="matSort">
                <!-- displayName Column -->
                <ng-container matColumnDef="displayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'contentTypes.displayName' | translate}}"> {{'contentTypes.displayName' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.displayName) {
                      <span class="text-wrap text-break">{{row.displayName}}</span>
                    }
                  </td>
                </ng-container>

                <!-- name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'contentTypes.name' | translate}}"> {{'contentTypes.name' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.name) {
                      <span class="text-wrap text-break">{{row.name}}</span>
                    }
                  </td>
                </ng-container>

                <!-- description Column -->
                <ng-container matColumnDef="info">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'contentTypes.description' | translate}}"> {{'contentTypes.description' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.info) {
                      <span class="text-wrap text-break"> {{row.info}}</span>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="tokenMenu">
                      <mat-icon matPrefix>more_vert</mat-icon>
                    </button>
                    <mat-menu #tokenMenu="matMenu">
                      <button mat-menu-item (click)="openEditInterface(row)">
                        <mat-icon matPrefix>edit</mat-icon> {{'edit' | translate}}
                      </button>
                      <button mat-menu-item (click)="deleteInterface(row)" [disabled]="!interfacesUserRights_delete">
                        <mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{'delete' | translate}}
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedInterfaceColumns;sticky:true;" class="p-1"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedInterfaceColumns;" class="p-1 element-row text-wrap text-break"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4"><div class="p-5">{{'empty' | translate}}</div></td>
                </tr>
              </table>
              <mat-paginator #interfacesPaginator [pageSizeOptions]="paginatorSize" aria-label="Select page of users" showFirstLastButtons class="pb-2"></mat-paginator>
            </div>
          </div>
        </div>
      </div>

    </mat-tab>
    <mat-tab label="API Tokens">
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined me-2">token</mat-icon>
        <!-- {{'interfaces.title' | translate}} -->
        API Tokens
      </ng-template>
      <div class="p-4">
        <div class="row mt-4">
          <div class="col-12">
            <section class="mt-1 filter-section d-flex flex-row flex-wrap align-items-center">
              <div>
                <button mat-button class="orange-button mb-2" (click)="openDialogNewToken();" [disabled]="!interfacesUserRights_create">
                  <mat-icon>add_circle</mat-icon>
                  {{'add_new' | translate}}
                </button>
              </div>
              <mat-form-field class="pt-3 m-2 my-0 search">
                <mat-label>{{'search_title' | translate}}</mat-label>
                <input matInput (keyup)="applyTokensFilter($event)" placeholder="{{'search' | translate}}" #input>
                <mat-icon matPrefix>search</mat-icon>
              </mat-form-field>
            </section>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <div class="rounded shadow-sm mb-4" id="table-container">
              <table mat-table [dataSource]="tokenlistdata" matSort #tokensSort="matSort">
                <!-- displayName Column -->
                <ng-container matColumnDef="displayName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'contentTypes.displayName' | translate}}"> {{'contentTypes.displayName' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.displayName) {
                      <span class="text-wrap text-break">{{row.displayName}}</span>
                    }
                  </td>
                </ng-container>

                <!-- creationDate Column -->
                <ng-container matColumnDef="creationDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="{{'reports.sorted_by' | translate}} {{'creation_date' | translate}}"> {{'creation_date' | translate}} </th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.creationDate) {
                      <span class="text-wrap text-break">{{row.creationDate.toDate() | date:'dd.MM.yyyy, HH:mm'}}</span>
                    }
                  </td>
                </ng-container>
                <!-- token Column -->
                <ng-container matColumnDef="token">
                  <th mat-header-cell *matHeaderCellDef>Token</th>
                  <td mat-cell *matCellDef="let row">
                    @if (row.token) {
                      <span class="text-wrap text-break"> {{row.token}}</span>
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="tokenMenu">
                      <mat-icon matPrefix>more_vert</mat-icon>
                    </button>
                    <mat-menu #tokenMenu="matMenu">
                      <button mat-menu-item (click)="copyToClipboard(row.token)">
                        <mat-icon matPrefix>content_copy</mat-icon> {{'copy' | translate}}
                      </button>
                      <button mat-menu-item (click)="deleteToken(row.token)" [disabled]="!interfacesUserRights_delete">
                        <mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{'delete' | translate}}
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedTokenColumns;sticky:true;" class="p-1"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedTokenColumns;" class="p-1 element-row text-wrap text-break"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4"><div class="p-5">{{'empty' | translate}}</div></td>
                </tr>
              </table>
              <mat-paginator #tokensPaginator [pageSizeOptions]="paginatorSize" aria-label="Select page of users" showFirstLastButtons class="pb-2"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-card>

<!-- </ng-container> -->
</section>